export default __webpack_public_path__ + "static/media/logowhite.30eb5d6f.png";